export default __webpack_public_path__ + "static/media/Smart Heart Puppy Dog Food.472671cf.png";